import NextImage from 'next/image'
import { Tile, TileImage, TileOverlay, BREAKPOINTS } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { DynamicHeroValues } from 'libs/dynamic-hero'
import { PrunedCourse } from 'libs/server/api'
import { personalizedHero } from '../utils'
import classes from './Hero.module.scss'

export const MobileBackgroundImage = () => {
  const { course, savedDynamicHero } = useStaticData<{
    course: PrunedCourse
    savedDynamicHero: DynamicHeroValues
  }>()
  const imageSrc =
    personalizedHero(savedDynamicHero)?.mobileImage || course.image16x9

  return (
    imageSrc && (
      <Tile>
        <TileImage
          image={
            <NextImage
              src={imageSrc}
              alt=''
              fill
              sizes={`(max-width: ${BREAKPOINTS.MD + 1}px) 100vw, 0vw`}
              style={{ objectFit: 'contain', objectPosition: 'top' }}
              priority
            />
          }
        />
        <div className={classes.blurOverlay} />
      </Tile>
    )
  )
}

// Desktop and Tablet
export const DesktopBackgroundImage = () => {
  const { course, savedDynamicHero } = useStaticData<{
    course: PrunedCourse
    savedDynamicHero: DynamicHeroValues
  }>()
  const imageSrc =
    personalizedHero(savedDynamicHero)?.image || course?.cinematic12x5

  return (
    <>
      {imageSrc && (
        <TileImage
          image={
            <NextImage
              src={imageSrc}
              alt=''
              fill
              // Desktop image is visible at MD breakpoint and above
              sizes={`(max-width: ${BREAKPOINTS.MD - 1}px) 0vw, 100vw`}
              style={{ objectFit: 'cover' }}
              priority
            />
          }
        />
      )}
      <TileOverlay color='0,0,0' className={classes.desktopOverlay} />
    </>
  )
}
